export class RoutePlanner {
    constructor() {
        this.$searchMapButton = document.querySelector('#journey_submit');
        this.$addressInput = document.getElementById('journey_address');
        this.init();
    }

    init() {
        if(!this.$searchMapButton) return;

        let storesAddress = this.$addressInput.dataset.store;
        this.$searchMapButton.addEventListener('click', () => {
            window.open('https://www.google.com/maps/dir/?api=1&destination=' + storesAddress + '&travelmode=driving&origin=' + this.$addressInput.value);
        });
    }
}
